import { render, staticRenderFns } from "./OmsButton.vue?vue&type=template&id=f39b7d40&scoped=true"
import script from "./OmsButton.vue?vue&type=script&lang=js"
export * from "./OmsButton.vue?vue&type=script&lang=js"
import style0 from "./OmsButton.vue?vue&type=style&index=0&id=f39b7d40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39b7d40",
  null
  
)

export default component.exports